import { applyMiddleware, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunkMiddleware from 'redux-thunk';

import appReducer from './redux/reducers';
import { IAdviserTotal, IAppState } from './types/';
import gaLogger from './middleware/ga-logger';
import sideEffectMiddleware from './middleware/sideEffects';
import { getConfig, getSidebarState } from './helpers/storage';

const configData = getConfig();

const initState: IAppState = {
  user: {
    name: '',
    email: '',
    id: '',
    sk: '',
    picture: '',
    firstName: '',
    lastName: '',
    data: '',
    currentFamilyId: '',
    walkthroughCompleted: false,
    exploreCompleted: false,
    onboardingStep: 0,
    quotes: [],
    coverageCompleted: false,
  },
  referenceData: {
    policyTypes: [],
    policyProviders: [],
    policySubTypes: [],
    creditCards: [],
    employers: [],
    wiki: [],
    policyScan: {},
  },
  admin: {
    loading: false,
  },
  operations: {
    loading: false,
    addPolicyModelOpen: false,
    policyScans: [],
    emailNotification: [],
  },
  policies: {
    loading: true,
    scansLoading: true,
    policies: [],
    submitted: false,
    submitting: false,
    selectedPolicy: null,
    selectedPolicyScan: null,
    policyScans: [],
    policyReviews: [],
    bundles: [],
    error: '',
  },
  invitation: {
    loading: false,
    showCreateInvitationPage: true,
    invitations: [],
    sharedInvitations: [],
  },
  config: configData,
  adviser: {
    advisers: null,
    adviserConnects: null,
    premiumAdviserConnect: null,
    isConnected: false,
    submitted: false,
    submitting: false,
    loadingCalendar: true,
    loadingConsents: true,
    loaded: false,
    loading: false,
    isInquired: false,
    clients: [],
    consents: [],
    total: {} as IAdviserTotal,
    calendly: {},
    error: null,
  },
  payment: {
    loading: false,
    error: '',
    paymentResult: null,
    windcavePaymentResult: null,
  },
  creditCard: {
    creditCards: [],
    submitted: false,
    submitting: false,
    loaded: false,
  },
  policyRenewal: {
    renewals: [],
    pendingRenewals: [],
    submitted: false,
    submitting: false,
    loaded: false,
  },
  notification: {
    notifications: [],
    loading: false,
    bannerType: null,
  },
  layout: {
    expanded: getSidebarState(),
  },
  providentStripePayment: {
    paymentStatus: '',
    showStripe: false,
    stripeLoading: false,
  },
  navBar: {
    navbarTitle: undefined,
    showPolicyDetails: false,
    showUpdateMarketScanPopup: false
  },
  marketScanResults: {
    currentMarketScanResult: undefined,
    showHowToVideosPopup: false,
    isPurchaseFlowActive: false
  },
};

function configureStore(preloadedState: IAppState) {
  const middlewares = [thunkMiddleware, gaLogger, sideEffectMiddleware];
  const middlewareEnhancer = applyMiddleware(...middlewares);

  const composedEnhancers = composeWithDevTools(middlewareEnhancer);

  const store = createStore(appReducer, preloadedState, composedEnhancers);

  return store;
}

export default configureStore(initState);
